import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../utils/_services/api.service';
import { ToasterService } from '../utils/_services/toaster.service';
import { UtilsService } from '../utils/_services/utils.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  constructor(
    private _fb: FormBuilder,
    private api:ApiService,
    private utils: UtilsService,
    private router: Router,
    private toaster: ToasterService
  ) { }

  loginForm!: FormGroup;
  ngOnInit(): void {

    this.loginForm = this._fb.group({
      log_email: ['', Validators.compose([
        Validators.required,
        // Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,6}$")
        // Validators.pattern("^[a-z0-9]")
      ])],
      log_pwd: ['', Validators.compose([
        Validators.required
      ])]
    })

  }

  loginUser() {
    let request = this.loginForm.value;
    request.log_source = "email";
    this.api.login(request).subscribe((r) => {
      console.log(r);
      if (r.data?.success) {
        this.utils.loggedUser = {...r.data};
        this.utils.token = r.data.token_id;
        localStorage.setItem('loggedUser', JSON.stringify(r.data));
        localStorage.setItem('token', r.data.token_id);
        this.router.navigateByUrl('dashboard', {
          replaceUrl : true
        });
      } else if(r?.data?.inv_mail || r?.data?.inv_pwd){
        this.toaster.error({ message: 'Invalid Mail/Password'});
      }else{
        this.toaster.error({ message: 'Try again!!'});
      }
    });
  }



}
